import { api } from "./axiosClient";

export const organisationSecretApi = {
  searchOrganisationSecrets: async (payload: any) => {
    const response = await api.post("/organisationSecret/Search", payload);
    return response.data;
  },

  createOrganisationSecret: async (data: any) => {
    const response = await api.post("/organisationSecret/create", data);
    return response.data;
  },

  updateOrganisationSecret: async (data: any) => {
    const response = await api.post("/organisationSecret/edit", data);
    return response.data;
  },

  removeOrganisationSecret: async (id: string) => {
    return await api.post("/organisationSecret/remove", { id });
  },
};
